import { Action } from '@ngrx/store';
import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';
import { TopConfig } from '@ordersnproducts/modules/new-modify-order/modules/rms-top-location/models/config.model';

export enum TopLocationActionTypes {
  INIT = '[Top Location] Init',
  RESET = '[Top Location] Reset',
  ADD_ITEM = '[Top Location] Add recipe item',
  UPDATE_ITEM = '[Top Location] Update recipe item',
  UPDATE_POD = '[Top Location] Update POD',
  UPDATE_POD_MODIFY = '[Top Location] Update Pod',
}

export class TopLocationLoadAction implements Action {
  readonly type = TopLocationActionTypes.INIT;

  constructor(public payload: TopConfig) {}
}

export class TopLocationAddItemAction implements Action {
  readonly type = TopLocationActionTypes.ADD_ITEM;

  constructor(public payload?: { [key: string]: any }) {}
}

export class TopLocationUpdateItemAction implements Action {
  readonly type = TopLocationActionTypes.UPDATE_ITEM;

  constructor(public payload: RecipeFormValues) {}
}


export class TopLocationResetAction implements Action {
  readonly type = TopLocationActionTypes.RESET;

  constructor() {}
}

export class TopLocationUpdateSetPOD implements Action {
  readonly type = TopLocationActionTypes.UPDATE_POD;

  constructor(public pod: number | null | undefined) {}
}

export class TopLocationUpdateSetPodModify implements Action {
  readonly type = TopLocationActionTypes.UPDATE_POD_MODIFY;

  constructor(public pod: number) {}
}

export type TopLocationActions =
  | TopLocationLoadAction
  | TopLocationAddItemAction
  | TopLocationUpdateItemAction
  | TopLocationResetAction
  | TopLocationUpdateSetPodModify
  | TopLocationUpdateSetPOD;
